<template>
    <div>
        <h2>
            <nuxt-link :to="$web('areas.changes.show', [$route.params.area, item._key])">{{ item.title }}</nuxt-link>
        </h2>
        <div class="flex items-center mb-12">
            <badge v-if="$date().diff(item.published_at, 'days') < 3" color="secondary" class="mr-6" rounded spaced>NEU</badge>
            <badge v-if="item.priority === 1" color="gray-300" rounded spaced>Kleine Änderung</badge>
            <badge v-else-if="item.priority === 2" color="success" rounded spaced>Mittlere Änderung</badge>
            <badge v-else-if="item.priority === 3" color="error" rounded spaced>Wichtige Änderung</badge>
        </div>
        <user-content :text="displayContent"/>

        <wrapper between grow class="mt-24">
			<dynamic-date :date="item.published_at" small color="gray-400" time relative/>

			<btn v-if="stripedText.length > maxContentLength" :to="$web('areas.changes.show', [$route.params.area, item._key])">
				<span>Weiterlesen</span>
				<icon :icon="icons.next"/>
			</btn>
		</wrapper>
    </div>
</template>

<script setup lang="ts">
import {stripHtml} from "@spoferan/spoferan-ts-core";
import {truncate} from "@spoferan/spoferan-ts-core";
import {nextIcon} from "@spoferan/nuxt-spoferan/icons";

const props = defineProps<{
	item: object
}>();

const maxContentLength = 500;
const icons = {
	next: nextIcon,
};

const stripedText = computed(() => {
	return stripHtml(props.item.content);
});

const displayContent = computed(() => {
	return truncate(props.item.content, maxContentLength)
});

</script>